import { request } from "../../utils/request/request";

export const sendCompanyLeadDataForm = async (sentData) => {

    const response = await request.post('/lead/createCompany', sentData);

    return response.data;
};
